import { TControlledFormComponentProps } from '@chocolate-soup-inc/cs-frontend-components';
import { FieldValues } from 'react-hook-form';
import { TCompanyFieldsFragment, TDependantType } from '../../generated/graphql';

type TGetEmployeeDependantFormFieldsProps = {
  company?: TCompanyFieldsFragment;
  styles?: Record<string, any>;
};

export const getEmployeeDependantFormFields = <T extends FieldValues = FieldValues>(props?: TGetEmployeeDependantFormFieldsProps) => {
  const { company, styles } = props || {};

  const relationShipOptions = [];

  if (company?.significantOtherBirthdayActivated)
    relationShipOptions.push({
      value: TDependantType.SignificantOther,
      label: 'Significant Other'
    });

  if (company?.childBirthdayActivated)
    relationShipOptions.push({
      value: TDependantType.Child,
      label: 'Child'
    });

  if (company?.petBirthdayActivated)
    relationShipOptions.push({
      value: TDependantType.Pet,
      label: 'Pet'
    });

  const formFields: TControlledFormComponentProps[] = [
    {
      name: 'type',
      type: 'select',
      label: 'Relationship Type',
      inputOptions: {
        options: relationShipOptions
      }
    },
    {
      name: 'petType',
      label: 'Pet Type',
      type: 'textField',
      show: (data) => data.type === TDependantType.Pet
    },
    {
      name: 'firstName',
      label: 'First Name',
      type: 'textField'
    },
    {
      name: 'lastName',
      label: 'Last Name',
      type: 'textField',
      show: (data) => data.type !== TDependantType.Pet
    },
    {
      name: 'birthDate',
      label: 'Birth Date',
      type: 'datePicker'
    },
    {
      className: 'col-span-2',
      type: 'switch',
      label: 'Donate birthday gift to charity',
      name: 'donateBirthdayGift',
      show: (data) => data.type === TDependantType.SignificantOther
    },
    {
      className: styles?.foodPreferences,
      name: 'foodPreferences',
      label: 'Allergies & Dietary Restrictions',
      type: 'textArea'
    }
  ];
  return formFields as TControlledFormComponentProps<T>[];
};
